import { complianceNavigationItems, complianceRoutes } from "./router";
/**
 * Compliance Module — landing shell for the OPCONF compliance surface (US-1d).
 * No feature screens yet; catalog / requests / retention arrive in later stories.
 */
export class ComplianceModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[ComplianceModule] Registered");
        return {
            id: "compliance",
            name: "Compliance Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return complianceRoutes;
    }
    getNavigationItems() {
        return complianceNavigationItems;
    }
    getComponent(_slotName) {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[ComplianceModule] Unregistered");
        this.contracts = null;
    }
}
export default new ComplianceModule();
